module.exports = __webpack_public_path__ + "static/img/bg_one.56750fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/diagnosis/bg_one.png
// module id = ksf2
// module chunks = 3